// This is just an example,
// so you can safely delete all default props below

export default {
    button_restart_payment: 'Start betaling på nytt',
    button_search_trip: 'Nytt reisesøk',
    complete_order_failed_title: 'Feil',
    complete_order_failed_desc: 'Det oppstår feil under behandlingen av bestillingen.',
    payment_failed_title: 'Betaling mislyktes',
    payment_failed_desc: 'Betalingen din ble kansellert av deg eller mislyktes. Du kan klikke på knappen "Start betaling på nytt" for å velge en ny betalingsmåte.',
    reservation_failed_title: 'Det er ikke nok kapasitet eller utsolgt på den valgte turen',
    reservation_failed_desc: 'Det er ikke ledig plass på den valgte avgangen, prøv med et mindre antall passasjerer/kjøretøy eller velg en annen avgang. Bestillingen kan ikke fullføres for de valgte passasjerene/kjøretøyene.',
    booking_time_passed_title: "Bestillingstidspunktet passert",
    booking_time_passed_desc: "Bestillingstidspunktet for denne avgangen er nå passert, bestillingen kan ikke gjennomføres. Vennligst velg annen avgang/dato.",
    already_processed_title: 'Betaling er allerede utført.',
    already_processed_desc: 'Betalingen er allerede utført, vennligst sjekk epost for din bestilling.'
}
